import { createFCWidgetForLogin } from 'views/assets/scripts/friendlyCaptcha'
import registerSliderStretcher from 'views/assets/scripts/registerSliderStretcher'
import runScripts from 'views/assets/scripts/runScripts'
import { initSlider as slider } from 'views/assets/scripts/slider'

runScripts(createFCWidgetForLogin, slider, registerSliderStretcher)
